import React, {useState} from "react";
import {
  Box,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import moment from "moment";
import numberFormatter from "../../../../utils/number-formatter";
import clsx from "clsx";

const ContractSummary = ({ statistic }) => {
  const classes = useStyles();
  const contractSummary = statistic?.contract_summary;

  const [endDate] = useState(moment(contractSummary?.end_date));
  const [startDate] = useState(moment(contractSummary?.start_date));
  const [endDates] = useState(() => {
    const today = moment().startOf('day');
    const contractEnd = moment(endDate).startOf('day');
    const daysDiff = contractEnd.diff(today, 'days') + 1;
    return Math.max(0, daysDiff);
  });

  const progressPercent = Math.round(contractSummary?.progress_percent || 0);

  return (
    <Box className={classes.card}>
      <Box className={classes.header}>
        <div className={classes.title}>Сводка по контракту</div>
      </Box>

      <Box className={classes.amountRow}>
        <Typography className={classes.amount}>
          {numberFormatter(contractSummary?.report_done, {decimals: 0})} шт. из {numberFormatter(contractSummary?.total_reports, {decimals: 0})} шт.
        </Typography>
        <Tooltip title={contractSummary?.progress_status === 'behind' ? 'Отставание от графика' : 'Опережение графика'} arrow>
          <span className={clsx(classes.percentBadge, {
            '--danger': contractSummary?.progress_status === 'behind',
            '--success': contractSummary?.progress_status === 'ahead',
          })}>
            {progressPercent}%
          </span>
        </Tooltip>
      </Box>

      <Box className={classes.progressBar}>
        <Box className={classes.progressFill} sx={{ width: `${progressPercent}%` }} />
      </Box>

      <Box className={classes.datesRow}>
        <Box className={classes.dateBlock}>
          <span className={classes.dateLabel}>Начало оказания услуг</span>
          <Box className={classes.dateValueRow}>
            <span className={classes.dateValue}>{moment(startDate).format('DD.MM.YYYY')}</span>
          </Box>
        </Box>
        <Box className={classes.dateBlockRight}>
          <span className={classes.dateLabel}>Окончание оказания услуг</span>
          <Box className={classes.dateValueRow}>
            <span className={classes.dateValue}>{moment(endDate).format('DD.MM.YYYY')}</span>
            <span className={classes.daysLabel}>осталось дней</span>
            <span className={classes.dateValue}>{endDates}</span>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  card: {
    padding: 16,
    borderRadius: 8,
    background: "#FFFFFF",
    border: "1px solid #E4E4E7",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: "28px",
    color: "#111111",
  },
  amountRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 20,
  },
  amount: {
    fontSize: "24px !important",
    fontWeight: "500 !important",
    lineHeight: "28px !important",
    color: "#4F39F6 !important",
  },
  percentBadge: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "18px",
    color: "#432DD7",
    backgroundColor: "#E0E7FF",
    borderRadius: 16,
    padding: "2px 8px",
    "&.--danger": {
      color: "#DC2626",
      backgroundColor: "#FEE2E2",
    },
    "&.--success": {
      color: "#16A34A",
      backgroundColor: "#DCFCE7",
    },
  },
  progressBar: {
    height: 12,
    borderRadius: 6,
    backgroundColor: "#E4E4E7",
    marginBottom: 20,
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    borderRadius: 6,
    background: "linear-gradient(90deg, #A3B3FF 0%, #615FFF 50%, #432DD7 100%)",
  },
  datesRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  dateBlock: {
    display: "flex",
    gap: 12,
    alignItems: "baseline",
  },
  dateBlockRight: {
    display: "flex",
    gap: 12,
    alignItems: "baseline",
    justifyContent: "flex-end",
  },
  dateLabel: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "20px",
    color: "#000000",
  },
  dateValueRow: {
    display: "flex",
    gap: 12,
    alignItems: "center",
  },
  dateValue: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: "#432DD7",
  },
  daysLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "20px",
    color: "#000000",
  },
}));

export default ContractSummary;
